<template>
    <div class="cst-survey-answer cst-survey-answer-scale">
        <div class="currently-selected"> {{ currentlySelectedElement }} </div>
        <ul>
            <li :key="entry.name" @mouseover="currentlyHovered = entry" @mouseleave="currentlyHovered = false" v-for="entry in categories" v-bind:class="{ selected: question.answer.answerValue != '' && question.answer.answerValue == entry.percentage}" v-on:click="answer_question(entry.percentage)">
                <app-smiley :currentlyHighlightedCategoryName="currentlyHighlightedCategoryName" :category="entry"></app-smiley>
            </li>
        </ul>
    </div>
</template>

<script>
    /* global eventHub */
    /* eslint no-undef: "error" */
    import AppSmiley from './AppSmiley'

    export default {
      props: ['question'],
      data: function () {
        return {
          currentlyHovered: false,
          entryunselectedText: this.$t('smileyNotScored'),
          categories: [
            {
              name: 'veryunhappy',
              url: require('../assets/icon_survey_smiley-veryunhappy.svg'),
              percentage: 20,
              description: this.$t('smileyVeryUnhappy')
            },
            {
              name: 'unhappy',
              url: require('../assets/icon_survey_smiley-unhappy.svg'),
              percentage: 40,
              description: this.$t('smileyUnhappy')
            },
            {
              name: 'medium',
              url: require('../assets/icon_survey_smiley-medium.svg'),
              percentage: 60,
              description: this.$t('smileyMedium')
            },
            {
              name: 'happy',
              url: require('../assets/icon_survey_smiley-happy.svg'),
              percentage: 80,
              description: this.$t('smileyHappy')
            },
            {
              name: 'veryhappy',
              url: require('../assets/icon_survey_smiley-veryhappy.svg'),
              percentage: 100,
              description: this.$t('smileyVeryHappy')
            }
          ]
        }
      },
      computed: {
        currentlyHighlightedCategoryName: function () {
          if (this.currentlyHovered) {
            return this.currentlyHovered.name
          } else if (this.question.answer.answerValue !== '') {
            for (var category_index in this.categories) {
              var category = this.categories[category_index]
              if (category.percentage === this.question.answer.answerValue * 1) {
                return category.name
              }
            }
          } else {
            return ''
          }
        },
        currentlySelectedElement: function () {
          if (this.currentlyHovered) {
            return this.currentlyHovered.description
          } else if (this.question.answer.answerValue === '') {
            return this.entryunselectedText
          } else {
            for (var category_index in this.categories) {
              var category = this.categories[category_index]
              if (category.percentage === this.question.answer.answerValue) {
                return category.description
              }
            }
          }
        }
      },
      methods: {
        answer_question: function (answer) {
          eventHub.$emit('answer-question', { 'answerScore': answer, 'answerValue': answer, 'questionId': this.question.id })
        }
      },
      components: {
        AppSmiley
      }
    }
</script>

<style lang="less" scoped>
    @import '../_theme';

    ul {
        display: flex;
        justify-content: space-between;
        max-width: 35em;
        margin: 0 auto;
    }
    li {
        display: inline-block;
        flex: 1;
        text-align: center;
    }
    .currently-selected {
        text-align: center;
    }
    .cst-survey-answer-scale {
      padding: 0em 2em;
      border-top: 1px solid #ccc;
      padding-top: 1em;
    }

    @media (max-width: 1000px) {
        .cst-survey-answer-scale {
            padding: 1em 1em;
        }
    }

    @media (hover: none) { 
      .currently-selected {
        display: none
      }
    }

</style>


// WEBPACK FOOTER //
// src/components/CardAnswerScale.vue